import Container from './TitleBatchEdit.container';
import TitleBatchEdit from './TitleBatchEdit';

export default Container(TitleBatchEdit);
